import { DOCUMENT } from '@angular/common';
import { computed, Inject, Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export type AppLanguage = 'en' | 'ar';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly STORAGE_KEY = 'lang';

  readonly supportedLanguages: AppLanguage[] = ['en', 'ar'];

  currentLang = signal<AppLanguage>('en');

  readonly isRTL = signal(false);

  constructor(
    private translate: TranslateService,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  init(): void {
    this.translate.addLangs(this.supportedLanguages);
    const savedLang = (localStorage.getItem(this.STORAGE_KEY) as AppLanguage) || 'en';

    this.setLanguage(savedLang);
    this.translate.use(savedLang).subscribe({
      next: () => {
        console.log('File loaded!');
        console.log('instant test:', this.translate.instant('View All'));
      },
      error: (err) => console.error('Load error:', err),
    });
  }

  setLanguage(lang: AppLanguage): void {
    this.currentLang.set(lang);

    this.translate.use(lang);

    localStorage.setItem(this.STORAGE_KEY, lang);

    const isRtl = lang === 'ar';

    this.isRTL.set(isRtl);

    this.document.documentElement.lang = lang;
    this.document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
  }

  toggleLanguage(): void {
    const next = this.currentLang() === 'en' ? 'ar' : 'en';

    this.setLanguage(next);
  }
  readonly currentDirection = computed(() => (this.isRTL() ? 'rtl' : 'ltr'));
}
